import React, { useState } from 'react';
import { useParams } from 'react-router-dom';
import { Container, Card, CardBody, CardTitle, CardText, Button, Row, Col, Modal, ModalHeader, ModalBody, ModalFooter } from 'reactstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faStar, faUser, faHeart, faTimes } from '@fortawesome/free-solid-svg-icons';
import footerBg from "./../../assets/footerbg.jpg";
import dummy from "./../../assets/dummy.png";  

const districtPersons = {
  Ambala: [
    {
      name: "Late Manjeet Singh",
      rank: "Sep",
      unit: "NA",
      DOD: "07.06.1999",
      address: "Smt. Surjit Kaur (m), Vill – Kansapur",
      contact: "7082501901",
      bio: "",
      image: dummy,
    },
    {
      name: "Late Pawan Kumar",
      rank: "Sep",
      unit: "NA",
      DOD: "31.08.1999",
      address: "Smt. Sardari Devi, VPO- Gadhauli",
      contact: "9466503705",
      bio: "",
      image: dummy,
    },
  ],
  Bhiwani: [
    {
      name: "Sidh Ram",
      rank: "Hav",
      unit: "Grenadiers",
      DOD: "14.06.1999",
      address: "VPO - Pur",
      contact: "9812392299",
      bio: "",
      image: dummy,
    },
    {
      name: "Late Sanjay Singh",
      rank: "Gdr",
      unit: "Grenadiers",
      DOD: "24.09.1999",
      address: "VPO – Madh Madvi",
      contact: "9991420210",
      bio: "",
      image: dummy,
    },
  ],
  "Charkhi Dadri": [
    {
      name: "Late Lal Singh",
      rank: "Hav",
      unit: "Arty",
      DOD: "07.07.1999",
      address: "Vill – Gokul",
      contact: "9812782659",
      bio: "",
      image: dummy,
    },
    {
      name: "Late Suresh Kumar",
      rank: "Sep",
      unit: "Jat Regt",
      DOD: "17.05.1999",
      address: "Vill – Charkhi",
      contact: "9812088500",
      bio: "",
      image: dummy,
    },
    {
      name: "Late Randhir Singh, VrC",
      rank: "Sub",
      unit: "Gdr",
      DOD: "1999",
      address: "Vill – Balkara",
      contact: "NoK – Died",
      bio: "",
      image: dummy,
    },
    {
      name: "Late Rajvir Singh",
      rank: "Hav",
      unit: "Jat Regt",
      DOD: "17.05.1999",
      address: "Vill – Mouri",
      contact: "9050917141",
      bio: "",
      image: dummy,
    },
    {
      name: "Late Raj Kumar",
      rank: "LNK",
      unit: "Gdr",
      DOD: "14.06.1999",
      address: "Vill – Rawaldhi",
      contact: "9034622531",
      bio: "",
      image: dummy,
    },
    {
      name: "Late Kuldeep Singh",
      rank: "Sep",
      unit: "Jat Regt",
      DOD: "Jun-99",
      address: "Vill – Mehrana",
      contact: "9992411654",
      bio: "",
      image: dummy,
    },
  ],
  Fatehabad: [
    {
      name: "Late Manohar Lal",
      rank: "Gdr",
      unit: "18 Gdr",
      DOD: "13.06.1999",
      address: "Smt. Harkori (M) VPO – Dhani Dult",
      contact: "9416180185, 9461627735",
      bio: "",
      image: dummy,
    },
    {
      name: "Late Narender Singh",
      rank: "Sep",
      unit: "3 Jat Regt",
      DOD: "09.07.1999",
      address: "Smt. Reshma Devi (M), VPO – Mehuwala",
      contact: "9896423555",
      bio: "",
      image: dummy,
    },
    {
      name: "Late Bhim Singh",
      rank: "LNK",
      unit: "BSF",
      DOD: "04.09.1999",
      address: "Smt. Rajbala (W), VPO – Dhabi Khurd",
      contact: "9996378164",
      bio: "",
      image: dummy,
    },
  ],
  Faridabad: [
    {
      name: "Late Virender Kumar",
      rank: "Sep",
      unit: "Jat Regt",
      DOD: "03.07.1999",
      address: "VPO – Mohna",
      contact: "9467945966",
      bio: "",
      image: dummy,
    },
    {
      name: "Late Har Prasad",
      rank: "Sep",
      unit: "MLI",
      DOD: "25.06.1999",
      address: "VPO – Faridpur",
      contact: "9718512416",
      bio: "",
      image: dummy,
    },
  ],
  Gurugram: [
    {
      name: "Late Bijender Kumar",
      rank: "Sep",
      unit: "JAT Regt",
      DOD: "30.08.1999",
      address: "Vill – Daultabad Kuni",
      contact: "9812181511",
      bio: "",
      image: dummy,
    },
    {
      name: "Late Kailash Singh",
      rank: "Sub",
      unit: "Arty Regt",
      DOD: "18.01.2001",
      address: "Vill – Bhondsi",
      contact: "8375907982, 9911756628",
      bio: "",
      image: dummy,
    },
    {
      name: "Late Azad Singh",
      rank: "LNK",
      unit: "JAT Regt",
      DOD: "09.07.1999",
      address: "Vill – Mumtajpur",
      contact: "9992720267",
      bio: "",
      image: dummy,
    },
  ],
  Hisar: [
    {
      name: "Late Pavitar Kumar",
      rank: "Sep",
      unit: "8 Jat Regt",
      DOD: "09.07.1999",
      address: "Smt. Sujani Devi (M) VPO - Milakpur-1",
      contact: "9813052444",
      bio: "",
      image: dummy,
    },
    {
      name: "Late Mahavir Singh, SM",
      rank: "Hav",
      unit: "17 Jat Regt",
      DOD: "05.07.1999",
      address: "Smt. Javitri Devi (W), VPO - Ghirai",
      contact: "9896-53153",
      bio: "",
      image: dummy,
    },
  ],
  Jhajjar: [
    {
      name: "Late Jai Prakash",
      rank: "Hav",
      unit: "Guards",
      DOD: "05.05.1999",
      address: "VPO - Desalur",
      contact: "",
      bio: "",
      image: dummy,
    },
    {
      name: "Late Surender Singh",
      rank: "Gdr",
      unit: "Guards",
      DOD: "13.06.1999",
      address: "VPO - Subana",
      contact: "",
      bio: "",
      image: dummy,
    },
    {
      name: "Late Lila Ram",
      rank: "NK",
      unit: "AMC",
      DOD: "25.06.1999",
      address: "VPO - Jatwara",
      contact: "",
      bio: "",
      image: dummy,
    },
    {
      name: "Late Vinod Kumar",
      rank: "Signal Man",
      unit: "Signals",
      DOD: "14.06.1999",
      address: "VPO - Jaitpur",
      contact: "",
      bio: "",
      image: dummy,
    },
    {
      name: "Late Hari Om",
      rank: "Hav",
      unit: "Jat Regt",
      DOD: "07.07.1999",
      address: "VPO - Khungai",
      contact: "",
      bio: "",
      image: dummy,
    },
    {
      name: "Late Ramphal",
      rank: "NK",
      unit: "Mahar Regt",
      DOD: "06.07.1999",
      address: "VPO - Soldha",
      contact: "",
      bio: "",
      image: dummy,
    },
    {
      name: "Late Rajesh Kumar",
      rank: "LNK",
      unit: "Jat Regt",
      DOD: "07.07.1999",
      address: "VPO - Jhsnwa",
      contact: "",
      bio: "",
      image: dummy,
    },
    {
      name: "Late Dharmbir Singh",
      rank: "Sep",
      unit: "Jat Regt",
      DOD: "08.07.1999",
      address: "VPO - Dhakla",
      contact: "",
      bio: "",
      image: dummy,
    },
    {
      name: "Late Shyam Singh",
      rank: "NK",
      unit: "Grenadiers",
      DOD: "14.06.1999",
      address: "VPO - Nilothi",
      contact: "",
      bio: "",
      image: dummy,
    },
  ],
  Jind: [
    {
      name: "Late Ashish Kumar",
      rank: "Rfn",
      unit: "2 Raj Rif",
      DOD: "15.06.1999",
      address:
        "Smt. Bimla Devi, R/o VPO - Ghimana (Present r/o Gali No. 4, Chmela Colony, Narwana",
      contact: "8930056959, 9729566446",
      bio: "",
      image: dummy,
    },
  ],
  Kaithal: [],
  Karnal: [
    {
      name: "Late Parvesh Kumar",
      rank: "Rfn",
      unit: "Raj Rif",
      DOD: "06.06.1999",
      address:
        "Smt. Kamlesh Devi, R/o VPO - Makhala (Present home address - Nissing)",
      contact: "8168265323",
      bio: "",
      image: dummy,
    },
    {
      name: "Late Gulab Singh",
      rank: "Sep",
      unit: "4 Jat Regt",
      DOD: "21.06.1999",
      address: "Smt. Mero Devi, R/o VPO - Ballah",
      contact: "9996005192",
      bio: "",
      image: dummy,
    },
  ],
  Kurukshetra: [
    {
      name: "Late Sanjeev Kumar",
      rank: "Sep",
      unit: "Punjab Regt",
      DOD: "11.07.1999",
      address: "Smt. Parvati Devi (M), VPO – Kaulanpur",
      contact: "9416412623",
      bio: "",
      image: dummy,
    },
  ],
  Narnaul: [
    {
      name: "Late Parminder Singh",
      rank: "Gnr",
      unit: "Arty Regt",
      DOD: "21.06.1999",
      address:
        "Smt. Suman, R/o Keshav Nagar, Gali No. 3, Narnaul",
      contact: "7416907649",
      bio: "",
      image: dummy,
    },
    {
      name: "Late Ashok Kumar",
      rank: "Sep",
      unit: "NA",
      DOD: "06.09.1999",
      address: "Smt. Bhatery Devi (M), R/o VPO - Sehore",
      contact: "9992948821",
      bio: "",
      image: dummy,
    },
    {
      name: "Late Hanuman Singh",
      rank: "Ptr",
      unit: "PARA Regt",
      DOD: "25.07.1999",
      address: "Smt. Sarmila Devi, R/o VPO - Kotia",
      contact: "9466224934, 8059645602",
      bio: "",
      image: dummy,
    },
    {
      name: "Late Lal Singh",
      rank: "Nb Sub",
      unit: "NA",
      DOD: "02.05.1999",
      address: "Smt. Gyarsi Devi, R/o VPO - Guwani",
      contact: "9355144817",
      bio: "",
      image: dummy,
    },
    {
      name: "Late Ram Singh",
      rank: "Hav",
      unit: "NA",
      DOD: "NA",
      address: "Smt. Tarawati, R/o VPO - Rampura",
      contact: "8920094202",
      bio: "",
      image: dummy,
    },
    {
      name: "Late Satyapal",
      rank: "NK",
      unit: "NA",
      DOD: "NA",
      address: "Smt. Uganta Devi, R/o VPO - Sehore",
      contact: "9813647479",
      bio: "",
      image: dummy,
    },
    {
      name: "Late Birender Singh",
      rank: "NK",
      unit: "NA",
      DOD: "30.05.1999",
      address: "Smt. Manbhawati, R/o VPO - Garhi Ruthal",
      contact: "9050409400",
      bio: "",
      image: dummy,
    },
    {
      name: "Late Shiv Kumar",
      rank: "Hav",
      unit: "NA",
      DOD: "26.06.1999",
      address: "Smt. Santosh Devi, R/o VPO - Kakrala",
      contact: "9315453484",
      bio: "",
      image: dummy,
    },
    {
      name: "Late Khazan Singh",
      rank: "Hav",
      unit: "NA",
      DOD: "NA",
      address: "Smt. Rajbala, R/o VPO - Dongra Jat",
      contact: "",
      bio: "",
      image: dummy,
    },
    {
      name: "Late Lekh Ram",
      rank: "Hav",
      unit: "NA",
      DOD: "03.06.1999",
      address: "Smt. Krishana Devi, R/o VPO - Sahla",
      contact: "9466057312",
      bio: "",
      image: dummy,
    },
  ],
  Nuh: [],
  Palwal: [
    {
      name: "Late Rajbir Singh",
      rank: "LNK",
      unit: "17 Jat Regt",
      DOD: "06.07.1999",
      address: "Vill- Garhi Patti",
      contact: "9991969985",
      bio: "",
      image: dummy,
    },
    {
      name: "Late Zakir Hussain",
      rank: "LNK",
      unit: "22 Gdr",
      DOD: "03.07.1999",
      address: "Vill – softa",
      contact: "7838185323, 9310265007",
      bio: "",
      image: dummy,
    },
  ],
  Panchkula: [],
  Panipat: [],
  Rewari: [
    {
      name: "Late Din Dayal",
      rank: "Hav",
      unit: "97 Fd Regt (Artillery)",
      DOD: "12.08.1999",
      address: "Smt. Kamla Yadav, R/o VPO - Masani",
      contact: "9813112024, 9416907709",
      bio: "",
      image: dummy,
    },
    {
      name: "Late Hans Raj Yadav",
      rank: "CQMH",
      unit: "Kumaon Regt",
      DOD: "06.06.1999",
      address: "Smt. Sunita Devi, Vill - Jhal",
      contact: "9671553070, 9416329796",
      bio: "",
      image: dummy,
    },
  ],
  Rohtak: [
    {
      name: "Late Rajbir Singh",
      rank: "NK",
      unit: "Grenadier",
      DOD: "13.06.1999",
      address: "Smt. Anita",
      contact: "9991212223",
      bio: "",
      image: dummy,
    },
    {
      name: "Late Kuldeep Singh",
      rank: "Sep",
      unit: "Jat Regt",
      DOD: "18.06.1999",
      address: "Smt. Sudesh Malik",
      contact: "9466072017",
      bio: "",
      image: dummy,
    },
    {
      name: "Late Suresh",
      rank: "NK",
      unit: "Raj Rif",
      DOD: "10.07.1999",
      address: "Smt. Sulekha",
      contact: "9671935309",
      bio: "",
      image: dummy,
    },
    {
      name: "Late Jasvir Singh",
      rank: "NK",
      unit: "Raj Rif",
      DOD: "13.06.1999",
      address: "Smt. Sunita",
      contact: "8607318345",
      bio: "",
      image: dummy,
    },
    {
      name: "Late Jasbir Singh",
      rank: "Sep",
      unit: "Raj Rift",
      DOD: "29.06.1999",
      address: "Smt. Inderwati",
      contact: "9466008969",
      bio: "",
      image: dummy,
    },
    {
      name: "Late Vijay Singh",
      rank: "LNK",
      unit: "Jat Regt",
      DOD: "06.07.1999",
      address: "Smt. Satwanti",
      contact: "9416065323",
      bio: "",
      image: dummy,
    },
    {
      name: "Late Krishan Lal",
      rank: "NK",
      unit: "Jat Regt",
      DOD: "06.07.1999",
      address: "Smt. Rajpati",
      contact: "9896388033",
      bio: "",
      image: dummy,
    },
  ],
  Sirsa: [
    {
      name: "Late Krishan Kumar",
      rank: "Sep",
      unit: "17 Jat Regt",
      DOD: "30.05.1999",
      address: "Smt. Santosh, VPO - Tarkanwali",
      contact: "8221915461, 9416671490",
      bio: "",
      image: dummy,
    },
    {
      name: "Late Radhe Shyam",
      rank: "Sep",
      unit: "13 Raj Rit",
      DOD: "17.12.1999",
      address: "Smt. Silochana Devi, VPO - Beharwala",
      contact: "9416644933, 9671060633",
      bio: "",
      image: dummy,
    },
  ],
  Sonipat: [
    {
      name: "Late Lachhman Singh",
      rank: "Hav",
      unit: "NA",
      DOD: "09.06.1999",
      address: "Smt. Shaukantla Devi, Vill – Mahalna",
      contact: "9467443111, 9992040000",
      bio: "",
      image: dummy,
    },
    {
      name: "Late Bhim Singh",
      rank: "NK",
      unit: "NA",
      DOD: "12.06.1999",
      address: "Smt. Sunita Devi, Vill – Gohana",
      contact: "9899954105, 9255805398, 9416644481",
      bio: "",
      image: dummy,
    },
    {
      name: "Late Ravinder Singh",
      rank: "Sep",
      unit: "NA",
      DOD: "06.06.1999",
      address: "Smt. Murti Devi, Vill – Rohtana",
      contact: "0130-2584992",
      bio: "",
      image: dummy,
    },
    {
      name: "Late Sukhbir Singh",
      rank: "Sep",
      unit: "NA",
      DOD: "13.06.1999",
      address: "Smt. Chanda Devi, Vill – Rukhi",
      contact: "9813865867, 9466406390, 9812558178",
      bio: "",
      image: dummy,
    },
    {
      name: "Late Mahavir Singh",
      rank: "Nb Sub",
      unit: "NA",
      DOD: "02.09.1999",
      address: "Smt. Shakuntala Devi, Vill – Bhanderi",
      contact: "9050655993, 9813865867",
      bio: "",
      image: dummy,
    },
    {
      name: "Late Satbir Singh Mor",
      rank: "NK",
      unit: "NA",
      DOD: "31.03.1999",
      address: "Smt. Sheela Devi, Jain Bagh Colony, Sonipat",
      contact: "9813758960, 9992097562",
      bio: "",
      image: dummy,
    },
  ],
  "Yamuna Nagar": [
    {
      name: "Late Navin Kumar Mehta",
      rank: "Hav",
      unit: "Rajput Regt",
      DOD: "22.05.1999",
      address: "Smt. Dolly Mehta (W), #275-R, Model Town, Yamuna Nagar",
      contact: "9017111462",
      bio: "",
      image: dummy,
    },
  ],
};


const MartyrsDetails = () => {
    const { districtName } = useParams();
    const persons = districtPersons[districtName] || [];
    const [modal, setModal] = useState(false);
    const [selectedPerson, setSelectedPerson] = useState(null);

    const toggleModal = (person) => {
        setSelectedPerson(person);
        setModal(!modal);
    };

    return (
        <>
            <div style={{
                backgroundImage: `url(${footerBg})`,
                backgroundSize: 'cover',
                backgroundPosition: 'center',
                padding: '30px 0',
                color: 'white',
                margin: '2%',
                borderRadius: '10px'
            }}>
                <Container>
                    <h3 className="fw-bold mb-0 text-center">
                        <FontAwesomeIcon icon={faHeart} className="me-2" />
                        {districtName} Martyrs
                    </h3>
                </Container>
            </div>

            <Container className="py-5">
                <Row className="justify-content-center">
                    {persons.length === 0 ? (
                        <Col lg={12}>
                            <Card className="border-0 text-center" style={{ borderRadius: '20px', padding: '50px', boxShadow: '0 12px 40px rgba(0,0,0,0.1)' }}>
                                <FontAwesomeIcon icon={faStar} style={{ fontSize: '3rem', color: '#6c757d', marginBottom: '20px' }} />
                                <h5 style={{ color: '#6c757d' }}>No Details available for {districtName} district.</h5>
                            </Card>
                        </Col>
                    ) : (
                        persons.map((person, index) => (
                            <Col key={index} md="4" xs="12" sm="6" className="mb-4">
                                <Card className="h-100 border-0" style={{ 
                                    borderRadius: '20px', 
                                    overflow: 'hidden',
                                    boxShadow: '0 8px 32px rgba(30,60,114,0.15)',
                                    transition: 'all 0.3s ease'
                                }}>
                                    <div style={{
                                        background: 'linear-gradient(135deg, #1e3c72 0%, #2a5298 100%)',
                                        padding: '20px',
                                        position: 'relative'
                                    }}>
                                        <div className="d-flex justify-content-center">
                                            <img
                                                src={person.image || dummy}
                                                alt={person.name}
                                                style={{
                                                    width: '100px',
                                                    height: '100px',
                                                    borderRadius: '50%',
                                                    border: '4px solid rgba(255,255,255,0.3)',
                                                    objectFit: 'cover',
                                                    boxShadow: '0 8px 25px rgba(0,0,0,0.2)'
                                                }}
                                            />
                                        </div>
                                    </div>
                                    <CardBody className="text-center p-4">
                                        <CardTitle tag="h5" className="fw-bold mb-2" style={{ color: '#1e3c72' }}>
                                            {person.name}
                                        </CardTitle>
                                        <CardText style={{ color: '#6c757d', fontWeight: '600' }}>
                                            {person.rank}
                                        </CardText>
                                        <Button 
                                            style={{
                                                background: 'linear-gradient(135deg, #1e3c72 0%, #2a5298 100%)',
                                                border: 'none',
                                                borderRadius: '20px',
                                                padding: '10px 25px',
                                                fontWeight: '600'
                                            }} 
                                            onClick={() => toggleModal(person)}
                                            onMouseOver={(e) => {
                                                e.currentTarget.style.background = 'linear-gradient(135deg, #16a085 0%, #27ae60 100%)';
                                                e.currentTarget.style.transform = 'scale(1.05)';
                                            }}
                                            onMouseOut={(e) => {
                                                e.currentTarget.style.background = 'linear-gradient(135deg, #1e3c72 0%, #2a5298 100%)';
                                                e.currentTarget.style.transform = 'scale(1)';
                                            }}
                                        >
                                            <FontAwesomeIcon icon={faUser} className="me-2" />
                                            View Profile
                                        </Button>
                                    </CardBody>
                                </Card>
                            </Col>
                        ))
                    )}
                </Row>
            </Container>

            <Modal isOpen={modal} toggle={() => toggleModal(null)} centered size="lg">
                <ModalHeader 
                    toggle={() => toggleModal(null)}
                    style={{
                        background: 'linear-gradient(135deg, #1e3c72 0%, #2a5298 100%)',
                        color: 'white',
                        border: 'none'
                    }}
                >
                    <FontAwesomeIcon icon={faHeart} className="me-2" />
                    {selectedPerson?.name}
                </ModalHeader>
                <ModalBody className="p-4">
                    {selectedPerson && (
                        <Row>
                            <Col md="4" className="d-flex justify-content-center align-items-center mb-4 mb-md-0">
                                <img
                                    src={selectedPerson.image || dummy}
                                    alt={selectedPerson.name}
                                    style={{
                                        width: '150px',
                                        height: '150px',
                                        borderRadius: '50%',
                                        border: '4px solid #1e3c72',
                                        objectFit: 'cover',
                                        boxShadow: '0 8px 25px rgba(30,60,114,0.3)'
                                    }}
                                />
                            </Col>
                            <Col md="8">
                                <div className="ps-md-4">
                                    <div className="mb-3">
                                        <small style={{ color: '#1e3c72', fontWeight: '600' }}>Rank</small>
                                        <p style={{ color: '#495057', fontWeight: 'bold' }}>{selectedPerson.rank}</p>
                                    </div>
                                    
                                    <div className="mb-3">
                                        <small style={{ color: '#1e3c72', fontWeight: '600' }}>Unit</small>
                                        <p style={{ color: '#495057' }}>{selectedPerson.unit}</p>
                                    </div>
                                    
                                    <div className="mb-3">
                                        <small style={{ color: '#1e3c72', fontWeight: '600' }}>Date of Death</small>
                                        <p style={{ color: '#495057' }}>{selectedPerson.DOD}</p>
                                    </div>
                                    
                                    <div className="mb-3">
                                        <small style={{ color: '#1e3c72', fontWeight: '600' }}>Permanent Address</small>
                                        <p style={{ color: '#495057' }}>{selectedPerson.address}</p>
                                    </div>
                                    
                                    <div className="mb-3">
                                        <small style={{ color: '#1e3c72', fontWeight: '600' }}>Contact</small>
                                        <p style={{ color: '#495057' }}>{selectedPerson.contact}</p>
                                    </div>
                                    
                                    {selectedPerson.bio && (
                                        <div>
                                            <small style={{ color: '#1e3c72', fontWeight: '600' }}>Details</small>
                                            <p style={{ color: '#495057', lineHeight: '1.7' }}>{selectedPerson.bio}</p>
                                        </div>
                                    )}
                                </div>
                            </Col>
                        </Row>
                    )}
                </ModalBody>
                <ModalFooter style={{ borderTop: '1px solid #e9ecef', background: '#f8f9fa' }}>
                    <Button
                        style={{
                            background: 'linear-gradient(135deg, #1e3c72 0%, #2a5298 100%)',
                            border: 'none',
                            borderRadius: '10px',
                            padding: '10px 25px',
                            fontWeight: '600'
                        }}
                        onClick={() => toggleModal(null)}
                    >
                        <FontAwesomeIcon icon={faTimes} className="me-2" />
                        Close
                    </Button>
                </ModalFooter>
            </Modal>
        </>
    );
};

export default MartyrsDetails;
